import { render, staticRenderFns } from "./shopQualification.vue?vue&type=template&id=5a6789d8&scoped=true"
import script from "./shopQualification.vue?vue&type=script&lang=js"
export * from "./shopQualification.vue?vue&type=script&lang=js"
import style0 from "./shopQualification.vue?vue&type=style&index=0&id=5a6789d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6789d8",
  null
  
)

export default component.exports